import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { useViewport } from '../../hooks/useViewport';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { Text } from 'foundations-components/components/Text';

// TODO: Can we migrate this to a trellis color? Asked on issue: https://git.hubteam.com/HubSpot/developer-documentation-onboarding-planning/issues/560#issuecomment-10895506
import { jsx as _jsx } from "react/jsx-runtime";
export const CODE_SAMPLE_BACKGROUND = '#2d3e50';
const MediaBarWrapper = styled.div.withConfig({
  displayName: "MediaBar__MediaBarWrapper",
  componentId: "sc-153tc3z-0"
})(["background-color:", ";"], CODE_SAMPLE_BACKGROUND);
const MediaBar = ({
  children,
  onCopyValue,
  value = ''
}) => {
  const {
    isBelowLaptop
  } = useViewport();
  return /*#__PURE__*/_jsx(MediaBarWrapper, {
    children: /*#__PURE__*/_jsx(MediaObject, {
      paddingInlineStart: isBelowLaptop ? '0' : '1000',
      paddingBlockEnd: "200",
      paddingBlockStart: "200",
      itemRight: /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        children: /*#__PURE__*/_jsx(CopyButton, {
          use: "link-on-dark",
          paddingInlineStart: "200",
          paddingInlineEnd: "200",
          value: value,
          onClick: onCopyValue,
          size: "extra-small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.codeSample.copyAll"
          })
        })
      }),
      children: children
    })
  });
};
export default MediaBar;